const BalanceSkeleton = () => (
  <div className="animate-pulse w-[250px] flex">
    <div className="h-[40px] bg-gray-300 w-[195px] mb-1" />
    <div className="h-[40px] bg-gray-300 w-[45px] mb-1 ml-2" />
  </div>
);

export default BalanceSkeleton;
